//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DetailList from '@/components/tools/DetailList';
import SettingItem from '@/components/setting/SettingItem';
import config from '@/defaultSettings';
import { updateTheme, updateColorWeak, colorList } from '@/components/tools/setting';
import { mixin, mixinDevice } from '@/utils/mixin.js';
import { triggerWindowResizeEvent } from '@/utils/util';
export default {
  components: {
    DetailList: DetailList,
    SettingItem: SettingItem
  },
  mixins: [mixin, mixinDevice],
  data: function data() {
    return {
      visible: true,
      colorList: colorList,
      dataFixSiderbar: false
    };
  },
  watch: {},
  mounted: function mounted() {
    var vm = this;
    setTimeout(function () {
      vm.visible = false;
    }, 16); // 当主题色不是默认色时，才进行主题编译

    if (this.primaryColor !== config.primaryColor) {
      updateTheme(this.primaryColor);
    }

    if (this.colorWeak !== config.colorWeak) {
      updateColorWeak(this.colorWeak);
    }

    if (this.multipage !== config.multipage) {
      this.$store.dispatch('ToggleMultipage', this.multipage);
    }
  },
  methods: {
    showDrawer: function showDrawer() {
      this.visible = true;
    },
    onClose: function onClose() {
      this.visible = false;
    },
    toggle: function toggle() {
      this.visible = !this.visible;
    },
    onColorWeak: function onColorWeak(checked) {
      this.$store.dispatch('ToggleWeak', checked);
      updateColorWeak(checked);
    },
    onMultipageWeak: function onMultipageWeak(checked) {
      this.$store.dispatch('ToggleMultipage', checked);
    },
    handleMenuTheme: function handleMenuTheme(theme) {
      this.$store.dispatch('ToggleTheme', theme);
    },
    handleLayout: function handleLayout(mode) {
      this.$store.dispatch('ToggleLayoutMode', mode); // 因为顶部菜单不能固定左侧菜单栏，所以强制关闭

      this.handleFixSiderbar(false); // 触发窗口resize事件

      triggerWindowResizeEvent();
    },
    handleContentWidthChange: function handleContentWidthChange(type) {
      this.$store.dispatch('ToggleContentWidth', type);
    },
    changeColor: function changeColor(color) {
      if (this.primaryColor !== color) {
        this.$store.dispatch('ToggleColor', color);
        updateTheme(color);
      }
    },
    handleFixedHeader: function handleFixedHeader(fixed) {
      this.$store.dispatch('ToggleFixedHeader', fixed);
    },
    handleFixedHeaderHidden: function handleFixedHeaderHidden(autoHidden) {
      this.$store.dispatch('ToggleFixedHeaderHidden', autoHidden);
    },
    handleFixSiderbar: function handleFixSiderbar(fixed) {
      if (this.layoutMode === 'topmenu') {
        fixed = false;
      }

      this.dataFixSiderbar = fixed;
      this.$store.dispatch('ToggleFixSiderbar', fixed);
    }
  }
};